import store from '@/store'
import { find } from 'lodash'
import { accessDeniedToaster } from '../pop-denied-access'

let guard = () => new Promise((resolve, reject) => {

  return find(store.getters['auth/abilities'], ability =>
    ability.name === 'site-failed-checkpoints-activity-report' &&
    ability.entity_type === 'Billow\\Models\\Site',
  ) ? resolve() : accessDeniedToaster(reject, { name: 'dashboard' })
})

export default {
  name: 'site-failed-checkpoints-activity-report',
  run: guard,
}
